import { getRequest, postRequest } from 'features/common'
import settings from 'settings'
import { ExtendedWorkflow, Workflow, WorkflowDemo } from '../types'
import { getClient } from 'features/common/utils/clientParameter'

const { workspaceApiUrl } = settings

export const createDemoWorkflow = async (demo: WorkflowDemo): Promise<Workflow> => {
  return await postRequest(`${workspaceApiUrl}/workflows/demo`, {
    demoWorkflowUrl: demo.publicUrl,
    client: getClient()
  })
}

export const getDemoWorkflows = async (): Promise<Array<WorkflowDemo>> => {
  const demoWorkflows: WorkflowDemo[] = await getRequest(
    `${workspaceApiUrl}/workflows/demo/templates?client=${getClient()}`
  )
  const demos: WorkflowDemo[] = await Promise.all(
    demoWorkflows.map(async (demo) => {
      if (demo.workflow) {
        return {
          ...demo,
          exists: true
        }
      }
      const workflow: ExtendedWorkflow = await getRequest(`${demo.publicUrl}?client=${getClient()}`)
      const demoWorkflow: WorkflowDemo = {
        ...demo,
        workflow,
        exists: false
      }
      return demoWorkflow
    })
  )
  return demos
}
